<template>
  <div class="app-container">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-card class="box-card">
          <div class="left">
            <el-image
              fit="scale-down"
              :src="config.RESOURCES + userData.avatar"
              lazy
            >
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <span>宏云号: {{ userData.loginName }}</span>
            <span>昵称: {{ userData.nickName }}</span>
            <span
              >手机:
              {{ userData.mobilePhone ? userData.MobilePhone : "无" }}</span
            >
            <span
              >邮箱:
              {{ userData.loginEmail ? userData.LoginEmail : "无" }}</span
            >
          </div>
        </el-card>
      </el-col>
      <el-col :span="16">
        <el-card class="box-card">
          <el-form
            ref="form"
            :model="userForm"
            label-width="80px"
            style="margin-top: 20px"
          >
            <el-form-item label="专家认证">
              <el-tag type="warning" style="margin-right: 20px">未认证</el-tag>
              <el-button
                size="small"
                type="warning"
                @click="goToAuthentication()"
              >
                申请认证
              </el-button>
            </el-form-item>
            <el-form-item label="密码设置">
              <el-tag type="success" style="margin-right: 20px">已设置</el-tag>
              <el-button
                size="small"
                type="warning"
                @click="goToModifyPassword()"
              >
                修改密码
              </el-button>
            </el-form-item>
            <el-form-item label="宏云号">
              <el-input v-model="userForm.LoginName" style="width: 400px" />
            </el-form-item>
            <el-form-item label="昵称">
              <el-input v-model="userForm.Nickname" style="width: 400px" />
            </el-form-item>
            <el-form-item label="性别">
              <el-radio-group v-model="userForm.Sex">
                <el-radio :label="0">男</el-radio>
                <el-radio :label="1">女</el-radio>
                <el-radio :label="2">未知</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="手机号码">
              <el-input v-model="userForm.MobilePhone" style="width: 400px" />
            </el-form-item>
            <el-form-item label="生日">
              <el-date-picker
                v-model="userForm.BirthDate"
                type="date"
                placeholder="选择日期"
                style="width: 400px"
              />
            </el-form-item>
            <el-form-item label="国家">
              <el-input v-model="userForm.Nationality" style="width: 400px" />
            </el-form-item>
            <el-form-item label="省份">
              <el-input v-model="userForm.Province" style="width: 400px" />
            </el-form-item>
            <el-form-item label="城市">
              <el-input v-model="userForm.City" style="width: 400px" />
            </el-form-item>
            <el-form-item label="单位">
              <el-input v-model="userForm.Organization" style="width: 400px" />
            </el-form-item>
            <el-form-item label="地址">
              <el-input v-model="userForm.Address" style="width: 400px" />
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="onSubmit">
                保存
              </el-button>
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import storage from "good-storage";
import { USER_KEY } from "@/assets/constant";
export default {
  data() {
    return {
      userForm: {},
      userData: {
        avatar: "", // 头像
        loginName: "", // 宏云号
        nickName: "", // 昵称
        mobilePhone: "", // 手机号码
        loginEmail: "", // 邮箱
      },
    };
  },
  created() {
    this.getUserData();
  },
  methods: {
    getUserData() {
      // 从 localStorage 中获取数据
      const userData = storage.get(USER_KEY);
      //console.log(userData);

      if (!userData) {
        this.$alert("用户信息缺失，请重新登录", "", {
          confirmButtonText: "确定",
        });
      }

      this.userForm = Object.assign({}, this.userForm, userData);
      this.userData = {
        avatar: userData.Avatar, // 头像
        loginName: userData.LoginName, // 宏云号
        nickName: userData.Nickname, // 昵称
        mobilePhone: userData.MobilePhone, // 手机号码
        loginEmail: userData.LoginEmail, // 邮箱
      };
      console.log(" ------------------------------------------");
      console.log("getUserData - this.userData", this.userData);
      console.log(" ------------------------------------------");
    },
    onSubmit() {
      console.log("submit!");
    },
    /**
     *
     */
    goToAuthentication(index, row) {
      this.$router.push({
        name: "authentication",
        params: {
          row: row,
        },
      });
    },
    /**
     *
     */
    goToModifyPassword(index, row) {
      this.$router.push({
        name: "modifyPassword",
        params: {
          row: row,
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.left {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    margin: 40px 0;
  }

  span {
    width: 250px;
    height: 40px;
    line-height: 40px;
  }
}
</style>
